<template>
  <div class="pagoda-detail-layout-v1" ref="content" >
    <!-- 标题区 -->
    <div class="pagoda-detail-layout-v1__bar" :class="{'bar-border': !isTouchTop}">
      <div class="detail-v1-back" @click="back">
        <span>{{backText}}</span>
      </div>
      <div class="detail-v1-center">{{contentTitle}}</div>
      <div class="detail-v1-btn">
        <slot name="content-btn"></slot>
      </div>
    </div>
    <div class="pagoda-detail-layout-v1__content" ref="contentBox">
      <!-- 表单区 -->
      <div class="detail-v1-form">
        <slot name="content-form"></slot>
      </div>
      <!-- 主内容区 -->
      <div class="detail-v1-detail">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailLayoutV1',
  props: {
    backUrl: {
      type: String,
      default: ''
    },
    backText: {
      type: String,
      default: '返回上级'
    },
    contentTitle: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      isTouchTop: true
    }
  },
  mounted () {
    let _this = this
    _this.contentBox = _this.$refs.contentBox
    _this.contentBox.addEventListener('scroll', () => {
      if (_this.$refs.contentBox.scrollTop !== 0) {
        this.isTouchTop = false
      } else {
        this.isTouchTop = true
      }
    }, false)
  },
  methods: {
    // 返回上一级路由的钩子函数
    back () {
      this.$emit('back')
    }
  }
}
</script>
